

const Footer = () => {
  return (
    <footer className="footer ">
      <div className="footerText1">Powered by PwC &nbsp;&nbsp;</div>
      <div className="footerText1">The model may provide inaccurate or incomplete information. Please verify the information provided.</div>
    </footer>
  )
};
export default Footer;
